import { handleException } from 'clients/exception-handling'
import type { SelectedRegion } from 'features/bug-report/types'

export async function captureFullPage(): Promise<string | null> {
  try {
    const { default: html2canvas } = await import('html2canvas-pro')
    const canvas = await html2canvas(document.body, {
      scale: 1,
      useCORS: true,
      logging: false,
    })
    return canvas.toDataURL('image/png')
  } catch (cause) {
    handleException(cause, { operation: 'bug-report.screenshot.capture' })

    return null
  }
}

export async function captureRegion(
  region: SelectedRegion,
): Promise<string | null> {
  try {
    const { default: html2canvas } = await import('html2canvas-pro')
    const canvas = await html2canvas(document.body, {
      x: region.x + window.scrollX,
      y: region.y + window.scrollY,
      width: region.width,
      height: region.height,
      scale: 1,
      useCORS: true,
      logging: false,
    })
    return canvas.toDataURL('image/png')
  } catch (cause) {
    handleException(cause, { operation: 'bug-report.screenshot.region' })

    return null
  }
}
